<div class="row no-gutters p-3">
  <div class="col-12 text-center text-primary">
    <i class="fas fa-spinner fa-2x fa-spin"></i>
  </div>
</div>
